import { useScrollReveal } from "../../../hooks/useScrollReveal";
import "./Impact02.css";

import icon from "../../../img/icons/check.svg";

/**
 * @param {{ cards: { title: string; body: string }[] }} props
 */
function Impact02({ cards }) {
  const { ref, isVisible } = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`Impact02 section section-reveal ${isVisible ? "section--visible" : ""}`}
      id="Impact02"
    >
      <div className="container">
        <div className="Impact02-box">
          {cards.map((card) => (
            <div key={card.title} className="Impact02-card">
              <img src={icon} alt="tick icon" />
              <div className="Impact02-card-text">
                <h3>{card.title}</h3>

                <p>{card.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Impact02;
